import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

/** Pipe to bypass security and trust the given value to be safe style value */
@Pipe({
  name: 'safeStyle',
  standalone: false,
})
export class SafeStylePipe implements PipeTransform {
  /** Dependencies */
  constructor(protected sanitizer: DomSanitizer) {}

  /** Transform function of pipe */
  public transform(value: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(value);
  }
}
